/* eslint-disable */
import { CommonGet, CommonPost } from '../../../helpers/HttpClient';
import TokenDecoder from '../../../helpers/TokenDecoder';

export default {
    GetAllGroups,
    GetProductCategories,
    GetFactoriesByGroupID,
    GetAllFactoriesByFactoryType,
    GetProductsByFactoryIDProductcatogeryID,
    GetStockBalanceReportData,
    GetStockFreezeStatus,
    FreezeStock,
    UnfreezeStock,
};

async function GetAllGroups() {
    const response = await CommonGet('/api/Group/GetAllGroups', null);
    return response.data;
}

async function GetFactoriesByGroupID(groupID) {
    const response = await CommonGet('/api/OperationEntity/GetAllFactoriesByFactoryType', 'groupID=' + parseInt(groupID) + '&factoryType=' + parseInt(TokenDecoder.getFactoryTypeFromToken()));
    return response.data;
}

async function GetAllFactoriesByFactoryType(groupID, operationEntityTypeID) {
    const response = await CommonGet('/api/OperationEntity/GetAllFactoriesByFactoryType', 'groupID=' + parseInt(groupID) + '&factoryType=' + operationEntityTypeID);
    return response.data;
}

async function GetProductCategories() {
    const response = await CommonGet('/api/ProductCategory/GetProductCategoryDetails', null);
    return response.data;
}

async function GetProductsByFactoryIDProductcatogeryID(factoryID, productcatogeryID) {
    const response = await CommonGet('/api/Product/GetProductsByFactoryIDProductCategoryID', 'factoryID=' + factoryID + '&productcatogeryID=' + productcatogeryID);
    return response.data;
}

async function GetStockBalanceReportData(model) {
    const response = await CommonPost('/api/StockManagement/GetStockManagementReportData', null, model);
    return response.data;
}

async function GetStockFreezeStatus(groupID) {
    const response = await CommonGet('/api/StockManagement/GetStockFreezeStatus', 'groupID=' + parseInt(groupID));
    return response.data;
}

async function FreezeStock(groupID, createdBy) {
    const response = await CommonGet('/api/StockManagement/FreezeStock', 'groupID=' + parseInt(groupID) + '&createdBy=' + parseInt(createdBy));
    return response;
}

async function UnfreezeStock(groupID, modifiedBy) {
    const response = await CommonGet('/api/StockManagement/UnfreezeStock', 'groupID=' + parseInt(groupID) + '&modifiedBy=' + parseInt(modifiedBy));
    return response;
}



